import CurrentEnrollmentStatus from "enums/Enrollment/CurrentEnrollmentStatus";

const currentEnrollmentStatusDescription = {
    [CurrentEnrollmentStatus.Cancelled]: 'Cancelled',
    [CurrentEnrollmentStatus.DisEnrolledbyCms]: 'Disenrolled By CMS',
    [CurrentEnrollmentStatus.Disenrolled]: 'Disenrolled',
    [CurrentEnrollmentStatus.Denied]: 'Denied',
    [CurrentEnrollmentStatus.DisenrollmentPending]: 'Disenrollment Pending',
    [CurrentEnrollmentStatus.Eligible]: 'Eligible',
    [CurrentEnrollmentStatus.Enrolled]: 'Enrolled',
    [CurrentEnrollmentStatus.EnrollmentPending]: 'Enrollment Pending',
    [CurrentEnrollmentStatus.EnrollmentRejected]: 'Enrollment Rejected',
    [CurrentEnrollmentStatus.EnrollmentSentToCms]: 'Enrollment Sent To CMS',
    [CurrentEnrollmentStatus.InvoluntaryDisenrolled]:
        'Involuntary Disenrollment',
    [CurrentEnrollmentStatus.Ineligible]: 'Ineligible',
    [CurrentEnrollmentStatus.PendingDenial]: 'Pending Denial',
    [CurrentEnrollmentStatus.Pending]: 'Pending Enrollment',
    [CurrentEnrollmentStatus.SendEnrollmentToCms]: 'Send Enrollment To CMS',
    [CurrentEnrollmentStatus.VoluntaryDisenrolled]: 'Voluntary Disenrollment',
};

export default currentEnrollmentStatusDescription;